import type { Dispatch } from "redux";
import { ActionTypes } from "@/actions";
import { clearItemsCache } from "../api/itemsApi";
import { invalidateAllCachesUsedByFetchMeta } from "../api/tableData";
import { clearRelationLabelCache } from "../component/TableHelper";
import { normalizeOrgSegment, parseCollectionTablePath } from "../utils/collectionPaths";
import { clearPermissionCache } from "./usePermission";

export type ReloadAppConfigOptions = {
  /** Refetch the collection table for the current route (when on a collection page). */
  reloadCurrentCollection?: boolean;
  pathname?: string;
  tableMeta?: unknown[];
};

/**
 * Clears cached ACL results and reloads component config so menus and tables pick up new permissions.
 */
export function reloadAppConfig(
  dispatch: Dispatch,
  user: unknown,
  options: ReloadAppConfigOptions = {}
): void {
  if (!user) {
    return;
  }

  clearItemsCache();
  invalidateAllCachesUsedByFetchMeta();
  clearPermissionCache();
  clearRelationLabelCache();

  dispatch({ type: ActionTypes.CLEAR_TABLE_DATA });

  const pathname = options.pathname ?? "";
  const ctx =
    options.reloadCurrentCollection && pathname
      ? parseCollectionTablePath(pathname)
      : null;
  if (ctx?.tableKey) {
    dispatch({
      type: ActionTypes.CLEAR_TABLE_DATA,
      payload: { slug: ctx.tableKey },
    });
  }

  dispatch({ type: ActionTypes.COMPONENTS_REQUEST, payload: { user, force: true } });
  // ComponentTable refetches the current collection once when reloadConfigNonce increments.
  dispatch({ type: ActionTypes.UI_RELOAD_CONFIG });
}
